import { useIntl } from "react-intl";
import { DoughnutChart } from "../../../common/charts";
import CircularLoader from "../../../common/circularLoader";

const LearningStatusSummary = ({ data, loading = false }) => {
  const intl = useIntl();
  const documentStyle = getComputedStyle(document.documentElement);

  return (
    (!loading && (
      <DoughnutChart
        canDownload
        id="learning_status_summary"
        data={{
          labels: [
            intl.formatMessage({
              id: "overdue",
            }),
            intl.formatMessage({
              id: "completed",
            }),
            intl.formatMessage({
              id: "inprogress",
            }),
            intl.formatMessage({
              id: "notstarted",
            }),
          ],
          datasets: [
            {
              data: [
                data.find((item) => item.status === "OverDue")?.count || 0,
                data.find((item) => item.status === "Completed")?.count || 0,
                data.find((item) => item.status === "Started")?.count || 0,
                data.find((item) => item.status === "NotStarted")?.count || 0,
              ],
              backgroundColor: [
                documentStyle.getPropertyValue("--red-500"),
                documentStyle.getPropertyValue("--green-500"),
                "#0EA5E9",
                documentStyle.getPropertyValue("--orange-500"),
              ],
              hoverBackgroundColor: [
                documentStyle.getPropertyValue("--red-500"),
                documentStyle.getPropertyValue("--green-500"),
                "#0EA5E9",
                documentStyle.getPropertyValue("--orange-500"),
              ],
            },
          ],
        }}
      />
    )) || <CircularLoader size={230} />
  );
};

export default LearningStatusSummary;
